///<reference path="BaseScreen.ts"/>
namespace nscs.screen {

    export class InstructionScreen extends BaseScreen {

        bg:Phaser.GameObjects.Image;
        nextBtn:Phaser.GameObjects.Image;

        constructor(scene:Phaser.Scene) {
            super(scene);

            this.bg = new Phaser.GameObjects.Image(this.scene, -1, -1, 'ui-atlas', 'bg_story'+'0000');
            this.bg.setOrigin(0, 0);
            this.add(this.bg);
            this.bg.setInteractive({cursor: 'pointer'});
            this.bg.once('pointerup', this.skip);

            this.nextBtn = new Phaser.GameObjects.Image(this.scene, 240, 160, 'ui-atlas', 'btn_next_story'+'0000');
            this.add(this.nextBtn);
            this.nextBtn.setInteractive({cursor: 'pointer'});
            this.nextBtn.once('pointerup', this.skip);

            let label_next:Phaser.GameObjects.Text = this.scene.add.text(this.nextBtn.x, this.nextBtn.y-5, "", {
                "fontFamily": "ArcadeClassic",
                "fontSize": 22,
                "color": "#FFFFFF",
                "align": 'left'
            });
            label_next.setOrigin(0.5, 0.5);
            this.add(label_next);
            // nscs.gameplay.Gameplay.setText(label_next, 'NextBtn');
            label_next.setText('CLICK HERE');

            let label_Instruct1:Phaser.GameObjects.Text = this.scene.add.text(30, 25, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 10,
                "color": "#FFFFFF",
                "align": 'right',
                "lineSpacing": 7
            });
            label_Instruct1.setWordWrapWidth(325);
            this.add(label_Instruct1);
            nscs.gameplay.Gameplay.setText(label_Instruct1, 'Instruct1');

            let label_Instruct2:Phaser.GameObjects.Text = this.scene.add.text(160, 200, "", {
                "fontFamily": "Helvetica Rounded LT Black",
                "fontSize": 10,
                "color": "#FFFFFF",
                "align": 'left',
                "lineSpacing": 7
            });
            label_Instruct2.setWordWrapWidth(325);
            this.add(label_Instruct2);
            nscs.gameplay.Gameplay.setText(label_Instruct2, 'Instruct2');
            
            let story_cheif = new Phaser.GameObjects.Image(this.scene, 400, 100, 'ui-atlas', 'story_cheif'+'0000');
            this.add(story_cheif);
            this.add(new Phaser.GameObjects.Image(this.scene, 75, 210, 'ui-atlas', 'pam_sel' + '0000').setOrigin(0.5, 0.5));

            let pam_mc_eye = scene.add.sprite(92, 185, 'ui-atlas');
            let pam_mc_eye_anim:string = 'pam_mc_eye_anim';
            if (!scene.anims.exists(pam_mc_eye_anim)) {
                scene.anims.create({
                    key: pam_mc_eye_anim,
                    frames: scene.anims.generateFrameNames('ui-atlas', {
                        start: 0, end: 337, zeroPad: 4,
                        prefix: 'pam_mc_eye', suffix: ''
                    }),
                    frameRate: 60,
                    repeat: -1
                });
            }
            pam_mc_eye.play(pam_mc_eye_anim);
            this.add(pam_mc_eye);
        }

        private alreadySkipped:boolean = false;
        public skip:()=>void = ()=>{
            if (this.alreadySkipped) return;
            this.alreadySkipped = true;

            nscs.scene.MainScene.instance.switchScreen(new nscs.screen.ChooseCharacterScreen(this.scene));
            nscs.sound.SoundManager.getInstance().playSound('winnerSND');
        };

        private dc;
        public destroy(fromScene?: boolean): void {
            nscs.util.Functions.destroyDelayedCall(this.dc);
            super.destroy(fromScene);
        }

        public updateScreen(): void {
            super.updateScreen();

            if (!this.alreadySkipped) {
                if (nscs.scene.MainScene.instance.inputController.escPressedDownAndReleased()) {
                    nscs.scene.MainScene.instance.inputController.escPressUsed();
                    nscs.scene.MainScene.instance.switchScreen(new MainMenuScreen(this.scene));
                }
            }
        }
    }
}